import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseRegressLeadProps {
  id?: string
  onSuccess?: () => void
  onError?: (error: ErrorResponse) => void
}

export const useRegressPublicCompanyLead = ({ id, onSuccess, onError }: UseRegressLeadProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['regressPublicCompanyLead'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/public/leads/${id}/regress`)
    },
    onSuccess,
    onError,
  })
}
